var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMultipliersNav = function SvgMultipliersNav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#33658A",
    d: "M26 0a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6h20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M7.293 7.293a1 1 0 0 1 1.414 0L16 14.585l7.293-7.292a1 1 0 0 1 1.497 1.32l-.083.094L17.415 16l7.292 7.293.083.094a1 1 0 0 1-1.497 1.32L16 17.415l-7.293 7.292a1 1 0 0 1-1.497-1.32l.083-.094L14.585 16 7.293 8.707l-.083-.094a1 1 0 0 1 .083-1.32z"
  }))));
};

export { SvgMultipliersNav as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBmaWxsPSIjMzM2NThBIiBkPSJNMjYgMGE2IDYgMCAwIDEgNiA2djIwYTYgNiAwIDAgMS02IDZINmE2IDYgMCAwIDEtNi02VjZhNiA2IDAgMCAxIDYtNmgyMHoiLz48cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik03LjI5MyA3LjI5M2ExIDEgMCAwIDEgMS40MTQgMEwxNiAxNC41ODVsNy4yOTMtNy4yOTJhMSAxIDAgMCAxIDEuNDk3IDEuMzJsLS4wODMuMDk0TDE3LjQxNSAxNmw3LjI5MiA3LjI5My4wODMuMDk0YTEgMSAwIDAgMS0xLjQ5NyAxLjMyTDE2IDE3LjQxNWwtNy4yOTMgNy4yOTJhMSAxIDAgMCAxLTEuNDk3LTEuMzJsLjA4My0uMDk0TDE0LjU4NSAxNiA3LjI5MyA4LjcwN2wtLjA4My0uMDk0YTEgMSAwIDAgMSAuMDgzLTEuMzJ6Ii8+PC9nPjwvc3ZnPg==";